module.exports = __webpack_public_path__ + "media/packs/images/flags/MU-c238eafd2b1c9f5b5b43029c89906895.png";